moment = require 'moment'
_ = require 'underscore'
l = require 'lib/localize'

firstLessThanOrEqualTo = (n, dispatch) ->
  for entry in dispatch
    if _.isArray(entry)
      [cutoff, val] = entry
      if n <= cutoff
        return val
    else
      return entry
  throw new Error("no matching dispatch value for #{n}!")

makeDateDispatch = ({ complete, incomplete }) ->
  dispatcher = null
  (date, isComplete) ->
    # Because the dispatch values might be localized, and we can't
    # synchronously evaluate localized keys, we delay this until we
    # actually request something.
    if isComplete
      return complete()
    dispatcher ?= incomplete()
    firstLessThanOrEqualTo(moment(date).diff(moment(), 'hours', true), dispatcher)

module.exports =
  classForDueDate: makeDateDispatch
    complete: -> 'is-due-complete'
    incomplete: -> [
      [-36, 'is-due-past']
      [0, 'is-due-now']
      [24, 'is-due-soon']
      'is-due-future'
    ]
  titleForDueDate: makeDateDispatch
    complete: ->
      l('badge.due.complete')
    incomplete: -> [
      [-36, l('badge.due.overdue')]
      [0, l('badge.due.recently overdue')]
      [1, l('badge.due.less than an hour')]
      [24, l('badge.due.less than a day')]
      l('badge.due.later')
    ]
  relativeInfoForDueDate: makeDateDispatch
    complete: ->
      null
    incomplete: -> [
      [-36, l('badge.due.overdue short')]
      [0, l('badge.due.recently overdue short')]
      [24, l('badge.due.due soon short')]
      null
    ]



// WEBPACK FOOTER //
// ./app/scripts/views/internal/due-date-helpers.coffee